import { AxiosInstance, AxiosResponse } from "axios"

export interface GetCancellationReasonsResponse extends AxiosResponse {
  DATES_CHANGED: string
  FOUND_ANOTHER_PLACE: string
  FOUND_BETTER_PRICE: string
  EXTENUATING_CIRCUMSTANCE: string
  FEEL_UNCOMFORTABLE: string
  OTHER: string
}

export function getListOfCancellationReasonsAPI(
  axiosInstance: AxiosInstance,
): Promise<GetCancellationReasonsResponse> {
  return axiosInstance({
    method: "get",
    url: "/booking/cancellation-reasons",
  }) as Promise<GetCancellationReasonsResponse>
}
